import styled from "styled-components";
import { deviceSizesMin } from "../../../../DeviceSizes";

export const ArticleEditorContainer = styled.div`
  height: calc(100vh - 72px);
`;

export const ArticleEditorPageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  flex-wrap: wrap;

  @media only screen and ${deviceSizesMin.laptopL} {
    flex-direction: row;
    flex-wrap: nowrap;
  }
`;

export const ArticleEditorHeader = styled.div`
  min-height: 60px;
  background: white;
  display: flex;
  align-items: center;
  max-width: 100vw;

  width: 100%;
  margin: auto;

  @media only screen and ${deviceSizesMin.laptopL} {
    width: calc(1170px * 0.8);
  }
`;

export const ArticleEditorTitle = styled.h1`
  width: 100%;
`;

export const ArticleEditorSubmit = styled.button`
  margin: auto 0 auto auto;
  background: #007cba;
  color: white;
  text-decoration: none;
  text-shadow: none;

  display: inline-flex;
  font-size: 13px;
  border: 0;
  cursor: pointer;
  transition: box-shadow 0.1s linear;
  height: 36px;
  align-items: center;
  box-sizing: border-box;
  padding: 6px 12px;
  border-radius: 2px;

  &:hover {
    background: #006ba1;
  }
`;

export const ArticleEditorWrapper = styled.div`
  height: calc(100% - 60px);
  width: 100vw;

  margin: auto;

  @media only screen and ${deviceSizesMin.laptopL} {
    width: calc(1170px * 0.8);
  }
`;

export const ArticleEditorSideBarContainer = styled.div`
  width: 100vw;
  margin-top: 20px;
  margin-bottom: 20px;

  @media only screen and ${deviceSizesMin.laptopL} {
    display: inline-block;
    height: calc(100vh - 72px - 60px);

    margin-top: 60px;
    margin-left: 100px;
  }
`;

export const ArticleEditorSideBarImage = styled.img`
  margin: 50px auto auto auto;
  display: block;
  max-width: 200px;
  border: thick solid black;

  @media only screen and ${deviceSizesMin.laptopL} {
    max-width: 350px;
  }
`;

export const ArticleEditorSideBarImageUpload = styled.input`
  margin: 25px auto auto auto;
  display: block;
`;

export const ArticleEditorSideBarSportSelect = styled.select`
  margin: 25px auto auto auto;
  display: none;

  @media only screen and ${deviceSizesMin.laptop} {
    display: block;
  }
`;

export const ArticleEditorSideBarSportSelectLabel = styled.label`
  display: block;
`;

export const ArticleEditorSideBarButtons = styled.div`
  display: flex;
  flex-direction: row;
`;
